import config from "@/config";
import React from "react";
import { Link } from "react-router-dom";

const JobCategoryCard = ({ id, title, countJob, icon }) => {
  return (
    <Link to={`${config.routes.job}?nghenghiepId=${id}`} className="h-full group select-none md:min-h-64 bg-white rounded-lg p-4 hover:shadow-lg transition-all duration-300 cursor-pointer flex flex-col items-center justify-between hover:bg-slate-200">
      {/* Icon Section */}
      <i className={`${icon} text-7xl text-primary p-4 bg-opacity-10 rounded-full flex items-center justify-center mb-4`}></i>

      {/* Title */}
      <h3 className="text-gray-800 text-lg font-medium text-center mb-2``">
        {title}
      </h3>

      {/* Job Count - Green Bar */}
      <div className="w-full text-primary font-bold py-2 px-2 rounded-lg text-md text-center">
        <span>{countJob} việc làm</span>
      </div>
    </Link>
  );
};

export default JobCategoryCard;
